import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import DOMPurify from "dompurify";
import "./BlogDetails.css";

const BlogDetails = () => {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const res = await axios.get(`http://localhost:8080/api/blogs/${id}`);
                setBlog(res.data);
            } catch (err) {
                setError("Failed to load blog. Please try again later.");
            } finally {
                setLoading(false);
            }
        };
        fetchBlog();
    }, [id]);

    if (loading) return <p className="blog-message">Loading...</p>;
    if (error) return <p className="blog-message error">{error}</p>;
    if (!blog) return <p className="blog-message">No blog found.</p>;

    return (
        <div className="blog-container">
            <h1 className="blog-title">{blog.title}</h1>
            <p className="blog-meta">
                By {blog.author || "Anonymous"} • {new Date(blog.createdAt).toLocaleDateString()}
            </p>
            <p className="blog-intro">{blog.intro}</p>

            {/* Render React Quill HTML safely */}
            <div
                className="blog-content"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog.content) }}
            />
        </div>
    );
};

export default BlogDetails;
